import { Validator } from '@vueform/vueform';

export function getIsUniqueValidator(existingValues = [], message = '') {
  return class extends Validator {
    get message() {
      return message || 'The value already exists';
    }

    check(value) {
      return !existingValues.includes(value);
    }
  };
}

export function validateName(name, delimiter) {
  const column_name = name.split(delimiter).pop();
  if (column_name.length > 48) {
    return { isValid: false, message: 'Name cannot exceed 48 characters' };
  }
  return { isValid: true, message: '' };
}

export function getColumnNameValidator(delimiter = '/') {
  return class extends Validator {
    get message() {
      return 'Name cannot exceed 48 characters';
    }

    check(value) {
      const { isValid } = validateName(value, delimiter);
      return isValid;
    }
  };
}
